export const REQUEST_MASTER_TUTORIAL = "REQUEST_MASTER_TUTORIAL";
export const SET_MASTER_TUTORIAL = "SET_MASTER_TUTORIAL";
export const ERROR_GET_MASTER_TUTORIAL = "ERROR_GET_MASTER_TUTORIAL";

export const REQUEST_CREATE_MASTER_TUTORIAL = "REQUEST_CREATE_MASTER_TUTORIAL";
export const SUCCESS_CREATE_MASTER_TUTORIAL = "SUCCESS_CREATE_MASTER_TUTORIAL";
export const ERROR_CREATE_MASTER_TUTORIAL = "ERROR_CREATE_MASTER_TUTORIAL";

export const REQUEST_UPDATE_MASTER_TUTORIAL = "REQUEST_UPDATE_MASTER_TUTORIAL";
export const SUCCESS_UPDATE_MASTER_TUTORIAL = "SUCCESS_UPDATE_MASTER_TUTORIAL";
export const ERROR_UPDATE_MASTER_TUTORIAL = "ERROR_UPDATE_MASTER_TUTORIAL";

export const REQUEST_DELETE_MASTER_TUTORIAL = "REQUEST_DELETE_MASTER_TUTORIAL";
export const SUCCESS_DELETE_MASTER_TUTORIAL = "SUCCESS_DELETE_MASTER_TUTORIAL";
export const ERROR_DELETE_MASTER_TUTORIAL = "ERROR_DELETE_MASTER_TUTORIAL";

export const SET_MESSAGE_MASTER_TUTORIAL = "SET_MESSAGE_MASTER_TUTORIAL";
